import { z } from "zod";
export const accidentRelatedSchema = [
	{
		type: "group-input",
		name: "accidentRelated",
		title: "Accident",
		description: "Is this visit related to an Automobile or Work Accident?",
		fieldProps: {
			direction: "column",
		},
		group: [
			{
				type: "radio",
				name: "accidentRelated.accident",
				fieldProps: {
					options: [
						{ label: "No", value: "No" },
						{ label: "Yes, Automobile Accident", value: "Automobile Accident" },
						{ label: "Yes, Work Accident", value: "Work Accident" },
					]
				}
			},
			{
				type: "date",
				name: "accidentRelated.date",
				label: "Date of Accident",
				fieldProps: {
					formatValue: "MM/DD/YYYY",
					disableFuture: true,
				},
				conditional: {
					label: "accidentRelated.accident",
					values: ["Automobile Accident", "Work Accident"],
				},
				rule: z.coerce.date().max(new Date(), "Date of accident must be in the past"),
			},
			{
				type: "input",
				name: "accidentRelated.accidentInsurance",
				label: "Name of Insurance Carrier",
				conditional: {
					label: "accidentRelated.accident",
					values: ["Work Accident"],
				},
				rule: z.string().min(1, "Name of insurance carrier is required"),
			},
			{
				type: "input",
				name: "accidentRelated.employer",
				label: "Name of Employer (at time of injury)",
				conditional: {
					label: "accidentRelated.accident",
					values: ["Work Accident"],
				},
				rule: z.string().min(1, "Name of employer is required"),
			},
			{
				type: "input",
				name: "accidentRelated.accidentInsurance",
				label: "Name of No-Fault Carrier",
				conditional: {
					label: "accidentRelated.accident",
					values: ["Automobile Accident"],
				},
				rule: z.string().min(1, "Name of no-fault carrier is required"),
			}
		]
	}
]

export default accidentRelatedSchema;